import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import Icon from '../common/icons/Icon';
import querystring from 'querystring';
import Pagination from 'rc-pagination';
import USLocale from 'rc-pagination/lib/locale/en_US';
import 'rc-pagination/assets/index.css';

class UserListPage extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    users: PropTypes.object,
  };

  constructor(props) {
    super(props);

    const { search } = props.location;
    const qs = search ? querystring.parse(search.slice(1)) : {};

    this.state = {
      name: qs.name || '',
      page: qs.page || 1,
    };
  }

  setName = e => {
    this.setState({
      name: e.currentTarget.value,
      page: 1,
    });
  };

  setPage = page => {
    this.setState({ page }, this.submitSearch);
  };

  submitSearch = e => {
    if (e) e.preventDefault();

    const { name, page } = this.state;
    const qs = {
      page: page && page > 0 ? page : 1,
    };

    if (name.trim()) {
      qs.name = name;
    }

    this.props.history.push(`${this.props.match.path}?${querystring.stringify(qs)}`);
  };

  render() {
    const { users, location } = this.props;
    const { name, page } = this.state;

    return (
      <div>
        <div className="admin-paper">
          <div className="admin-paper__header">
            <h3>User List</h3>
            <form onSubmit={this.submitSearch}>
              <input type="text" value={name} onChange={this.setName} placeholder="Search by Name or Email" />
              <button>
                <Icon icon="Search" />
              </button>
            </form>
          </div>
          <ul className="admin-paper__list">
            {users.getIn(['data', 'results']).size ? (
              users.getIn(['data', 'results']).map(user => (
                <li key={`user-${user.get('id')}`}>
                  <div className="admin-paper__list__title">
                    {user.get('name') ? user.get('name') : user.get('email')}
                  </div>
                  <Link className="admin-paper__list__link" to={`/users/${user.get('id')}${location.search}`}>
                    View Profile <Icon icon="Arrow" />
                  </Link>
                </li>
              ))
            ) : (
              <div className="admin-paper__no-content">No users found</div>
            )}
          </ul>
        </div>
        <div className="admin-pagination__wrapper">
          {users.getIn(['data', 'pagination', 'rowCount']) > users.getIn(['data', 'pagination', 'pageSize']) ? (
            <Pagination
              onChange={this.setPage}
              current={parseInt(page, 10)}
              pageSize={users.getIn(['data', 'pagination', 'pageSize'])}
              total={users.getIn(['data', 'pagination', 'rowCount'])}
              locale={USLocale}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(state => ({
    users: state.users.users,
  }))(UserListPage)
);



// WEBPACK FOOTER //
// ./src/users/UserListPage.js